module.exports = __webpack_public_path__ + "static/media/lead.f2d15b1e.png";